
    import { defineComponent } from 'vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue'
    import TitleAndPromotions from '@/apps/shared/components/TitlesAndPromotions.vue';
    import ExtendedContactInfo from "@/apps/shared/components/ExtendedContactInfo.vue";
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import DiscountRangeService from '@/apps/shared/services/getDiscountRange-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import localityService from '@/apps/shared/services/locality-service';

    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';
    export default defineComponent({
        components: {
            XBreadcrumb,
            ExtendedContactInfo,
            TitleAndPromotions,
        },
        data() {
            return {
                titleAndPromotionDetails: {
                    title: "PC, Notebook o Tablet",
                    subTitle: "Para comenzar, vamos a pedirte algunos datos personales",
                    product: "Tecnología",
                    icon: {
                        src: '/Logos/tecnologia.svg',
                        alt: 'Tecnologia',
                        title: 'Tecnologia'
                    },
                    iconPromotion: {
                        src: '/Logos/tecnologia-promo.png',
                        alt: 'logoHotWeek',
                        title: 'HotWeek'
                    },
                } as TitleAndPromotionsDetails,
                validatePhone: false,
                firstName: '',
                lastName: '',
                telephone: '',
                areaCode: '',
                email: '',
                localityList:
                    function (params) {
                        return localityService.getLocalityList(params)
                    },
                selectedLocality: null,
                autocompleteConfig: {
                    formatResult: NF.Autocomplete.Result.TAGS,
                    selection: NF.Autocomplete.Result.TAGS,
                    minimumInputLength: 4
                },
                discountRate: null,
                fechaPromotions: null,
                responseDiscountRange: null,
                containDiscountRange: false,
                changeTitlePromotions: false,
                sendDataDiscount: null,
                breadcrumItems: [
                    { text: 'Inicio', path: '/tecnologia' },
                    { text: 'Datos Personales', path: '/tecnologia/' },
                ],
                leadId: null,
                referente: null,
                medium: null,
                pas: null,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Tecnología';
                const actualPath = '/tecnologia';
                const actualStep = 'tab-one';
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, null);
                    const title = this.$store.getters.getWebSaleData?.pageCustomization?.navbar?.title ?? '';
                    this.pas = title === defaultTitle ? null : title;
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultElectronicDeviceGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            async comenzar() {
                const extendedContactInfoData = this.$refs.extendedContactInfoRef.getFormData();
                NF.Validation.Form.validate('#formData');
                this.validatePhone = false;
                const { firstName, lastName, email, telephone, areaCode, validTelephone, validEmail } = extendedContactInfoData;
                this.firstName = firstName;
                this.lastName = lastName;
                this.email = email;
                this.telephone = telephone;
                this.areaCode = areaCode;
                this.validatePhone = validTelephone;
                const validName = firstName && firstName.trim() !== "";
                const validLastName = lastName && lastName.trim() !== "";
                const validateEmail = validEmail;
                const validSelectedLocality = this.selectedLocality != null;

                if (validName && validLastName && this.validatePhone && validateEmail && validSelectedLocality) {
                    NF.UI.Page.block();
                    //------------------------------------------------------------
                    return new Promise<any>(async (resolve) => {
                        CRMCotizadorWebService.CreateOrEditLead(this.leadId, this.email, location.href, this.areaCode, this.telephone, 1000, false, "1", null, this.lastName, this.firstName).then((response) => {
                            resolve(true);
                            sessionStorage.setItem("LeadId", JSON.stringify(response));

                            const eventData = {
                                'pas': this.pas, 
                                'email': this.email, 
                                'product': 'tecnologia',
                                'event': 'cotizador-tecnologia-datos-personales',
                                'referente': this.referente,
                                'medio': this.medium
                            };

                            window.globalThis.dataLayer.push(eventData);

                            const customWindow = window as typeof window & {
                                _qsie?: Array<typeof eventData>;
                            };

                            customWindow._qsie ??= [];
                            customWindow._qsie.push(eventData);

                            sessionStorage.setItem("TabOneWelcome", JSON.stringify({
                                firstName: this.firstName,
                                lastName: this.lastName,
                                areaCode: this.areaCode,
                                telephone: this.telephone,
                                email: this.email,
                                selectedLocality: this.selectedLocality
                            }));
                            this.$router.push({
                                name: 'cotizador-equipo-electronico',
                            })
                        });
                    });
                    //------------------------------------------------------------
                } else {
                    const eventData = {
                        'pas': this.pas,
                        'email': this.email,
                        'product': 'tecnologia',
                        'event': 'errorUsuario',
                        'paso': 'cotizador-tecnologia-datos-personales',
                        'referente': this.referente,
                        'medio': this.medium
                    };

                    window.globalThis.dataLayer.push(eventData);

                    const customWindow = window as typeof window & {
                        _qsie?: Array<typeof eventData>;
                    };

                    customWindow._qsie ??= [];
                    customWindow._qsie.push(eventData);
                }
            },
            async getElectronicEquipmentDiscountRange() {
                NF.UI.Page.block();
                await DiscountRangeService.getElectronicEquipmentDiscountRange().then((response) => {
                    this.containDiscountRange = response.length > 0;
                    if (this.containDiscountRange) {
                        this.responseDiscountRange = response;
                        this.discountRate = this.responseDiscountRange[0].discountMaxValue;
                        this.fechaPromotions = new Date();
                        const FechaInicioEvento = new Date("2024-05-16");
                        const FechaFinEvento = new Date("2024-05-19");
                        this.changeTitlePromotions = (this.fechaPromotions >= FechaInicioEvento && this.fechaPromotions <= FechaFinEvento);
                        this.sendDataDiscount = {
                            discountRate: this.discountRate,
                            containDiscountRange: this.containDiscountRange,
                            changeTitlePromotions: this.changeTitlePromotions,
                        };
                        this.$refs.titlesAndPromotions.setDiscountData(this.sendDataDiscount);
                    }
                }).finally(() => {
                    NF.UI.Page.unblock();
                });
            },
            getInitData() {
                this.leadId = JSON.parse(sessionStorage.getItem("LeadId"));
                var validBack = sessionStorage.getItem("pressBack");
                if (validBack) {
                    sessionStorage.removeItem("pressBack");
                    var dataTomador = sessionStorage.getItem("TabOneWelcome");
                    if (dataTomador != null) {
                        this.dataTomadorJson = JSON.parse(dataTomador!);
                        this.$refs.extendedContactInfoRef.setFormData(this.dataTomadorJson);
                        this.selectedLocality = this.dataTomadorJson.selectedLocality;
                    }
                }
                else {
                    const eventData = {
                        'pas': this.pas,
                        'email': this.email,
                        'product': 'tecnologia',
                        'event': 'cotizador-tecnologia-view',
                        'referente': this.referente,
                        'medio': this.medium
                    };

                    window.globalThis.dataLayer.push(eventData);

                    const customWindow = window as typeof window & {
                        _qsie?: Array<typeof eventData>;
                    };

                    customWindow._qsie ??= [];
                    customWindow._qsie.push(eventData);

                    sessionStorage.clear();
                    sessionStorage.setItem("Referente", this.referente);
                    sessionStorage.setItem("Medium", this.medium);
                    sessionStorage.setItem("ExitOrContinueModal", "true");
                }
            }
        },
        created() {
            window.globalThis.validateLocality = function () {
                return Boolean(this.selectedLocality);
            }.bind(this);
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                await this.pageCustomization();

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
                var medium = sessionStorage.getItem("Medium");
                medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium;

                const parallelPromises = [
                    this.updateByProductGoogleAnalytics(),
                    this.getElectronicEquipmentDiscountRange()
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);

                this.getInitData();

            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
